import { useNavigate, useParams } from "react-router-dom";
import { CustomDataTable, filterData, CustomSelect } from "../utilities/Actions/Hooks";
import { branchColumn, departmentData, ReportColumn } from "../utilities/ArrayHelper/ReportColumn";
import { ReportsToolbar } from "../utilities/Reusable/ReportToolbar";
import { use, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { LoginContext } from "../login/LoginContext";
import {ChangePasswordContext} from "../changepassword/ChangePasswordContext"
import { DashboardContext } from "./DashboardContext";
import { ModalForm } from "./Modal";
import ChangePassword from "../changepassword/ChangePassword";
import { FileModal } from "./FileModal";
import { BaseUrlContext } from "../context/BaseUrlContext";

export const Dashboard=() => {
  const { BaseUrl } = useContext(BaseUrlContext);
   const { allReports, setAllReports, userData, setUserData, handleLogout, handleRowClicked, handleDownload, handleDelete, fetchReports, currentFilter, setCurrentFilter, users, setUsers,tokenKey } = useContext(DashboardContext);
  const { handleOpenChangePassword } = useContext(ChangePasswordContext);
  const navigate = useNavigate();
     useEffect(() => {
        fetchReports(currentFilter); 
      },[currentFilter,setCurrentFilter,BaseUrl]);
      const [searchTerm, setSearchTerm] = useState('');
        const filteredData = useMemo(
            () => filterData(allReports, searchTerm, ["mrdName", "mrdNo", "userName", "refClinic","refDr","reptName","reptNo","created"]),
            [allReports, searchTerm]
        );

  return (
    <>
    <div className="container-fluid" style={{background: 'linear-gradient(to bottom left, #c7efffff, #f9f9f9)'}}>
      <div className="d-flex justify-content-between p-4">
        <div style={{ lineHeight: "1.5" }}>
          <h5 className= "userName" style={{ margin: 0, padding: 0 }}>{userData?.userName}</h5>
          <a className= "password" onClick={handleOpenChangePassword} style={{ fontSize: "13px", textDecoration: "underline", color: "#00ABEF", cursor: "pointer" }}>Change Password</a>
        </div>
        <div className="col-3">
        <CustomSelect
          className="custom-select"
          value={currentFilter}
          onChange={(e) => setCurrentFilter(e.target.value)}
          placeholder="Select an option"
          data={[
            { value: "notReviewed", label: "Not Reviewed" },
            { value: "reviewed", label: "Reviewed" },
            { value: "all", label: "All Reports" }
            ]}
        />
        </div>

        <div className="logout d-flex align-items-center">
          <button className="btn" style={{background: '#00ABEF',borderColor: '#00ABEF',color: 'white'}} onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </div>

    <div className="container-fluid mt-3 ">
      <div className="container-fluid content">
      <ReportsToolbar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        userData={userData}
        usersTable={() => navigate(`/dashboard/users?token=${tokenKey}`)} />
      
      <CustomDataTable
        columns={ReportColumn(null,handleDelete,userData)}
        data={filteredData || []}                        
        paginationPerPage={10}
        paginationRowsPerPageOptions={[5, 10, 15]}
        select={false}
        onRowClick={handleRowClicked}
      />

      <ChangePassword/>
      {/* <PdfHtmlModal
        show={reportOpen}
        onClose={() => setReportOpen(false)}
        blobPath={blobPath}
        fileName={fileName}
      /> */}
       <FileModal />
      </div>
    </div>
    <style>
      {
        `
        .form-control:focus {
                border-color: #9ee4ffff;
                box-shadow: 0 0 0 1px #9ee4ffff;
                border-radius: 4px;
                min-height: 40px;
                height: 38px;
                outline: none;
            }  
            .form-control:hover {
                border-color: #9ee4ffff;
                box-shadow: 0 0 0 1px #9ee4ffff;
                border-radius: 4px;
                min-height: 40px;
                height: 38px;
                outline: none;
            }   
            .form-control {
                border-color: #ccc;
                box-shadow: none;
                border-radius: 4px;
                min-height: 40px;
                height: 38px;   
            }    
        `
      }
    </style>
    </>
  );
}
